import { useEffect, useState } from 'react';
import { useConfiguratorContext } from '@/kenwood/configurator/context';
import getConnectionsData from '@/api/get/connectionsData';

const useConnectionsData = () => {
  const [
    { connectionsData },
    { setConnectionsData },
  ] = useConfiguratorContext();
  const [fetchingConnectionsData, setFetchingConnectionsData] = useState(false);
  const successCB = data => {
    setConnectionsData(data);
  };

  useEffect(() => {
    if (!connectionsData && !fetchingConnectionsData) {
      setFetchingConnectionsData(true);
      getConnectionsData({
        successCB,
      });
    }
  }, [setConnectionsData]);
};

export default useConnectionsData;
